import * as React from "react";
const SvgBr = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 45 45", ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  opacity: 1,
  fill: 222222,
  fillOpacity: 1,
  fillRule: "evenodd",
  stroke: "#222",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} }, /* @__PURE__ */ React.createElement("path", { d: "M9 39 36 39 36 36 9 36 9 39zM12.5 32 14 29.5 31 29.5 32.5 32 12.5 32zM12 36 12 32 33 32 33 36 12 36z", style: {
  strokeLinecap: "butt"
} }), /* @__PURE__ */ React.createElement("path", { d: "M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z", style: {
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
} }), /* @__PURE__ */ React.createElement("path", { d: "M14 16.5 11 14 34 14 31 16.5 14 16.5zM11 14 11 9 15 9 15 11 20 11 20 9 25 9 25 11 30 11 30 9 34 9 34 14 11 14z", style: {
  strokeLinecap: "butt"
} }), /* @__PURE__ */ React.createElement("path", { d: "M12 35.5 33 35.5 33 35.5M13 31.5 32 31.5M14 29.5 31 29.5M14 16.5 31 16.5M11 14 34 14", style: {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1,
  strokeLinejoin: "miter"
} })));
export default SvgBr;
